/**
    品牌列表
**/
<template>
  <div style="width: 1200px;
    margin: auto;">
    <!-- 面包屑导航 -->
    <el-breadcrumb class="breakcrumbHeader" separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>所有品牌</el-breadcrumb-item>
    </el-breadcrumb>
    <el-row v-loading='loading'>
      <el-col
        :span="24"
        class="bigoutBox"
      >
      <el-collapse v-for="(item,index) in brandListarr"
        :key="index" v-model="activeNames">
        <!-- <el-collapse-item :name="index"  v-if="item.brandList.length==0?false:true"> -->
        <el-collapse-item :name="index">
            <template slot="title">
              <span>{{item.bxscId}}</span>
                <router-link :to="`/goodsList?brandId=${item.category.bxscId}`" style="font-size:18px;padding-left: 40px;">{{item.category.name}}</router-link> 
            </template>
            <div>
                <ul class="clearfix row bransList">
                  <!-- 在循环体外面，则三级和二级分类不换行。-->
                  <li class="col-md-2 col-sm-3 col-xs-4"  v-for="(branditem,index) in item.brandList" :key="index">
                      <router-link :to="`/goodsList?brandId=${branditem.bXyBid}`"
                        class="category-list-img">
                          <img
                            :src="`${branditem.logo}`"
                            width="70" height="70" alt="华为">
                        </router-link> 
                        <router-link :to="`/goodsList?brandId=${branditem.bXyBid}`"
                            class="category-list-title">
                            {{branditem.name}}
                        </router-link>
                  </li>
              </ul>
              <div class="nodate"  v-if="item.brandList.length==0?true:false">
                  <div class="first">对不起，暂无相应的品牌!</div>
              </div>               
            </div>          
        </el-collapse-item>              
      </el-collapse>  
      </el-col>
    </el-row>

  </div>
</template>
<script>
import { brandListApi  } from '@/api/xunyou'
export default {
  data() {
    return {
        activeNames:[0],
        brandListarr:[],
        loading:false
    };
  },
  // 注册组件
  components: {},
  /**
   * 数据发生改变
   */

  /**
   * 创建完毕
   */
  created() {},
  mounted() {
    this.searchBrand()
  },

  /**
   * 里面的方法只有被调用才会执行
   */
  methods: {
    // 品牌查询
      searchBrand() {
          this.loading = true
         brandListApi()
            .then(res => {
              if (res.code == 0) {
                this.loading = false
                console.log(res.data)
                  this.brandListarr =res.data;
                  res.data.forEach((item,index)=>{
                    if(item.brandList.length!=0){
                      this.activeNames.push(index)
                    }
                  })
              } else {
                this.$message({
                  type: 'info',
                  message: res.msg
                })
              }
            })
            // .catch(err => {
            //   this.editFormVisible = false
            //   this.loading = false
            //   this.$message.error('查询红包失败，请稍后再试！')
            // })
    },
  },
};
</script>

<style scoped>
.breakcrumbHeader{
   margin:15px 0;     
}
ul.clearfix.row.bransList {
    border-top: 1px solid #e0e0e0;
}
.bransList li{
    display: inline-block;
    width: 200px;
    text-align: center;
    border-right: 1px solid #e0e0e0;
    height: 136px;
    padding-top: 30px;
    box-sizing: border-box;
}
.category-list-img, .category-list-title{
    display: block;
    font-size: 14px;
}
.nodate{
    text-align: center;
    margin-top: 10%;
    margin-bottom: 10%;
    font-size: 16px;
}
.nodate .first {
	margin: 40upx 0 12upx;
	font-size: 28upx;
}
</style>

 
 

 


// WEBPACK FOOTER //
// src/views/brand/index.vue